import { Dialog, Portal } from '@chakra-ui/react'
import { useEffect } from 'react'
import { IoPerson } from 'react-icons/io5'
import { Snippets, SnippetsHeading, SnippetsItem, SnippetsList } from 'uikit'
import { HeadingItem, ItemIcon, ItemText } from 'uikit/Snippets'
import { useFetchCustomerRelatedBy } from './services/useFetchCustomerRelatedBy'

export const InvitedUsersModal = ({ isOpen, onClose, originCode }) => {
  const { refetch: fetchCustomerRelatedBy, data: dataCustomerRelatedBy } =
    useFetchCustomerRelatedBy(originCode)

  useEffect(() => {
    if (originCode && isOpen) {
      fetchCustomerRelatedBy()
    }
  }, [isOpen, originCode])

  return (
    <Dialog.Root open={isOpen} onOpenChange={(e) => (e.open ? null : onClose())}>
      <Portal>
        <Dialog.Backdrop />
        <Dialog.Positioner>
          <Dialog.Content>
            <Dialog.Header>
              <Dialog.Title>Приглашены по коду</Dialog.Title>
              <Dialog.CloseTrigger mt={1} />
            </Dialog.Header>
            <Dialog.Body minH="300px" pb="30px">
              <Snippets columns="42px 1fr">
                <SnippetsHeading>
                  <HeadingItem />
                  <HeadingItem>Пользователь</HeadingItem>
                </SnippetsHeading>
                <SnippetsList
                  activePage={0}
                  totalPages={0}
                  data={dataCustomerRelatedBy}
                  keyField="customerId"
                >
                  {(item) => {
                    return (
                      <SnippetsItem target="_blank" to={`/user/phone=${item?.customerId}`}>
                        <ItemIcon IconComponent={IoPerson} />
                        <ItemText>{item?.customerId}</ItemText>
                      </SnippetsItem>
                    )
                  }}
                </SnippetsList>
              </Snippets>
            </Dialog.Body>
          </Dialog.Content>
        </Dialog.Positioner>
      </Portal>
    </Dialog.Root>
  )
}
